export default __webpack_public_path__ + "static/media/adobe.f305b884.png";